import _ from 'lodash';
import React from 'react';
import FormattedField from './formatted-field';

export default (props) => (
    <FormattedField 
        {...props}
        prefix="%"
        format={ 
            (value) => {
                if (_.isEmpty(value)) {

                    return '';
                }

                value = window.parseInt(value.replace(/[^\d]+/, ''), 10);
                return `${value < 1 ? value * 100 : value}%`.replace(/nan/i, '0');
            }
        }
        removeFormatting={
            (value) => window.parseInt(value.replace(/[^\d]+/, ''), 10) / 100
        }
    />
);
